module.exports = __webpack_public_path__ + "img/water-trash.0e2a6f18.png";